import OnBoardNeofintechPhase1Routes from './phase1'
import OnBoardNeofintechPhase2Routes from './phase2'
import OnBoardNeofintechPhase3Routes from './phase3'

const myNeofintechRequests = [
  {
    path: '/verify-invitation',
    name: 'onBoard.neofintech.verifyInvitation',
    meta: {
      requiresAuth: false
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/InvitationCode.vue'
      )
  },
  {
    path: '/my-neofintech-requests',
    name: 'onBoard.neofintech.myNeofintechRequests',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/MyNeofintechRequests.vue'
      )
  },
  {
    path: '/my-neofintech-notifications',
    name: 'onBoard.neofintech.myNeofintechNotifications',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/MyNeofintechNotifications.vue'
      )
  },
  {
    path: '/my-neofintech-ecobanka-tv',
    name: 'onBoard.neofintech.myNeofintechEcobankaTV',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/myNeofintechEcobankaTV.vue'
      )
  },
  {
    path: '/my-neofintech-products',
    name: 'onBoard.neofintech.myNeofintechProducts',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/MyNeofintechProducts.vue'
      )
  },
  {
    path: '/my-dashboard',
    name: 'onBoard.neofintech.Dashboard',
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/DirectClientDashboard.vue'
      )
  },
  {
    path: '/my-neofintech-requests/:id',
    name: 'onBoard.neofintech.myNeofintechRequestDetail',
    props: true,
    meta: {
      requiresAuth: true
    },
    component: () =>
      import(
        /* webpackChunkName: "onboard" */
        '@/views/on-board/neofintech/MyNeofintechRequestDetail.vue'
      )
  }
]

export default {
  path: 'neofintech',
  name: 'onBoard.neofintech',
  children: OnBoardNeofintechPhase1Routes.concat(OnBoardNeofintechPhase2Routes)
    .concat(OnBoardNeofintechPhase3Routes)
    .concat(myNeofintechRequests),
  component: () =>
    import(
      /* webpackChunkName: "onboard" */
      '@/views/on-board/neofintech/Neofintech.vue'
    )
}
